module.exports = __webpack_public_path__ + "img/card7.7fe372ef.png";